export default __webpack_public_path__ + "static/media/memoryLossIcon.9ebe6523.svg";